mutation deleteHifoCascadePitchNote($id: ID!) {
  deleteHifoCascadePitchNote(input: { id: $id }) {
    success
  }
}
